import Vue from 'vue'
import App from './views/App.vue'
import vuetify from './plugins/vuetify';
import router from './router.js'
import Vuex from 'vuex'
import VueAnalytics from 'vue-analytics';


Vue.config.productionTip = false
Vue.use(Vuex)

/* Vuexストアを定義 */
const store = new Vuex.Store({
  state:{
    hiddenBtnFlg: false
  },
  mutations:{
    updateHiddenBtnFlg(state, newVal){
      state.hiddenBtnFlg = newVal
    },
  },
})

new Vue({
  vuetify,
  router,
  store,
  render: h => h(App)
}).$mount('#app')

// Configuration VueAnalytics
Vue.use(VueAnalytics, {
  id: 'G-6JBWF3XTRR',
  router
});